/**
 * @desc 批量导入海关要素
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/customsInfo/import/importExcelCustomsInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
